module.exports = __webpack_public_path__ + "img/bad-experience.50dcbefe.png";